const findLatestAttachment = (media, matches) =>
	(Array.isArray(media) ? media : [])
		.filter(
			item =>
				(item.collection || item.collection_name) === 'attachment' &&
				matches(item)
		)
		.reduce(
			(latest, item) =>
				!latest || Number(item.id) > Number(latest.id) ? item : latest,
			null
		)

// The parsing source: only feed this to CV enrichment, Replace must never re-parse.
export const findLatestUploadedCv = media =>
	findLatestAttachment(media, item => !!item.custom_properties?.is_cv_upload)

// Mirrors Media::isCvSlot(): flags decide the CV slot, never file content.
export const isCvSlotMedia = media =>
	!!(
		media?.custom_properties?.is_cv_upload ||
		media?.custom_properties?.is_shared_cv
	)

// The CV organisations see (ApplicantProfile::visibleAttachments()), for display only.
export const findLatestCvSlot = media =>
	findLatestAttachment(media, isCvSlotMedia)
